// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reports-module_content_box_VWYAy {
  padding: 6px 10px 10px;
  gap: 6px;
  height: 100%;
}

.Reports-module_report_table_box_pdO4p {
  height: auto;
  padding: 6px 20px 2px !important;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.Reports-module_report_table_box_loading__7Sof {
  padding: 20px !important;
}

.Reports-module_options_flex_box_uGZK8 {
  flex-wrap: nowrap;
  gap: 10px;
}

.Reports-module_options_flex_box_uGZK8 > * {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
}

.Reports-module_report_input_bnCqF,
.Reports-module_options_flex_box_uGZK8 input,
.Reports-module_options_flex_box_uGZK8 div.Reports-module_bp5-input_YvsIk {
  margin: 2px 0;
}

.Reports-module_options_label_fw_8x {
  white-space: nowrap;
}

.Reports-module_options_switch_F_zMN {
  margin-bottom: 0 !important;
}

.Reports-module_options_switch_F_zMN > span,
.Reports-module_options_switch_F_zMN > span > div {
  height: 24px !important;
}

.Reports-module_options_switch_F_zMN > span::before {
  height: 20px !important;
  margin-top: 2px !important;
  width: 20px !important;
}

.Reports-module_options_switch_checked_XACTw > span::before {
  left: calc(100% - 23px) !important;
}
.Reports-module_options_switch_unchecked_E8rhA > span::before {
  left: 0px !important;
}

.Reports-module_run_report_button_HmeGw {
}

.Reports-module_run_report_button_disabled_ML8Ff {
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Reports/Reports.module.css"],"names":[],"mappings":"AAAA;EAEE,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EAEE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,oBAAoB;AACtB;;AAEA;AAGA;;AAEA;AAGA","sourcesContent":[".content_box {\n  composes: panel_content_box_vertical from 'Styles/styles.module.css';\n  padding: 6px 10px 10px;\n  gap: 6px;\n  height: 100%;\n}\n\n.report_table_box {\n  height: auto;\n  padding: 6px 20px 2px !important;\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n}\n\n.report_table_box_loading {\n  composes: report_table_box;\n  padding: 20px !important;\n}\n\n.options_flex_box {\n  composes: panel_flex_box from 'Styles/styles.module.css';\n  flex-wrap: nowrap;\n  gap: 10px;\n}\n\n.options_flex_box > * {\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n}\n\n.report_input,\n.options_flex_box input,\n.options_flex_box div.bp5-input {\n  margin: 2px 0;\n}\n\n.options_label {\n  composes: bos_label from 'Styles/styles.module.css';\n  white-space: nowrap;\n}\n\n.options_switch {\n  margin-bottom: 0 !important;\n}\n\n.options_switch > span,\n.options_switch > span > div {\n  height: 24px !important;\n}\n\n.options_switch > span::before {\n  height: 20px !important;\n  margin-top: 2px !important;\n  width: 20px !important;\n}\n\n.options_switch_checked > span::before {\n  left: calc(100% - 23px) !important;\n}\n.options_switch_unchecked > span::before {\n  left: 0px !important;\n}\n\n.run_report_button {\n  composes: primary_button_bold from 'Styles/styles.module.css';\n  composes: bos_button_large from 'Styles/styles.module.css';\n}\n\n.run_report_button_disabled {\n  composes: disabled from 'Styles/styles.module.css';\n  composes: run_report_button;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_box": `Reports-module_content_box_VWYAy ${___CSS_LOADER_ICSS_IMPORT_0___.locals["panel_content_box_vertical"]}`,
	"report_table_box": `Reports-module_report_table_box_pdO4p`,
	"report_table_box_loading": `Reports-module_report_table_box_loading__7Sof Reports-module_report_table_box_pdO4p`,
	"options_flex_box": `Reports-module_options_flex_box_uGZK8 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["panel_flex_box"]}`,
	"report_input": `Reports-module_report_input_bnCqF`,
	"bp5-input": `Reports-module_bp5-input_YvsIk`,
	"options_label": `Reports-module_options_label_fw_8x ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_label"]}`,
	"options_switch": `Reports-module_options_switch_F_zMN`,
	"options_switch_checked": `Reports-module_options_switch_checked_XACTw`,
	"options_switch_unchecked": `Reports-module_options_switch_unchecked_E8rhA`,
	"run_report_button": `Reports-module_run_report_button_HmeGw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_bold"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_button_large"]}`,
	"run_report_button_disabled": `Reports-module_run_report_button_disabled_ML8Ff ${___CSS_LOADER_ICSS_IMPORT_0___.locals["disabled"]} Reports-module_run_report_button_HmeGw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_bold"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_button_large"]}`
};
export default ___CSS_LOADER_EXPORT___;
